module.exports = __webpack_public_path__ + "static/media/BB.9af45636.jpg";